/**
 * A person's name without their rank (owner, 2026-09-19, story 38): the rank
 * is shown beside the name, never inside it, so a search for "כהן" is not a
 * search through "סמל כהן". The one place a rank still leads the name is a
 * printed form, where the server composes it.
 */
export function personName(p) {
    return [p.firstName, p.lastName].filter(Boolean).join(' ');
}
//# sourceMappingURL=people.js.map